import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import {
  searchInstallment,
  downloadInstallmentIncomeDetail,
} from '../../redux/actions/projectBasedItems'
import { sessionGetItemJSON, sessionSetItemObj } from '../../utils/sessionHelpers'
import { startLoading, doneLoading } from '../../utils/loading'
import UpdateListVoucherListTable from './UpdateListVoucherListTable'
import AccountingPeriodWidget from '../panelHeder/AccountingPeriodWidget'
import MiniProjectInfo from './MiniProjectInfo'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, DELETE_ERR_MSG, DELETE_SUCCESS_MSG } from '../../constants/msgText'
import {
  deleteAdjust,
  downloadAdjustListFile,
  getAdjustList,
} from '../../redux/actions/accountingAdjust'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function UpdateListVoucherListWidget(props) {
  const { projectCode, periodNumber } = props

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState()
  const [deleteAdjustId, setDeleteAdjustId] = useState()

  const history = useHistory()

  const periodInfo = sessionGetItemJSON('periodInfo')

  const handleSearch = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAdjustList(projectCode, periodNumber, request)
      setFormSchema(response.model)
    } catch (error) {
      console.log('error ', error)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSelect = (rowData, type) => {
    // console.log('rowData===>', rowData)
    sessionSetItemObj('adjustData', { adjustId: rowData?.id, editMode: type == 'edit' })
    sessionSetItemObj('PreviewVoucherData', rowData)
    history.push({
      pathname: pathname.incomeAndExpense.UpdateList,
    })
  }

  const handleDelete = async (id) => {
    startLoading()
    setIsLoading(true)
    setDeleteAdjustId('')
    try {
      let response = await deleteAdjust(id)
      if (response) {
        notification.open('success', {
          title: DELETE_SUCCESS_MSG,
          duration: 5000,
        })

        doneLoading()

        handleSearch({})
      } else {
        notification.open('error', {
          title: DELETE_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      // console.log('error', e)
      notification.open('error', {
        title: DELETE_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handlePreviewVoucher = async (fileObj) => {
    // console.log('handlePreviewVoucher', fileObj)

    startLoading()
    setIsLoading(true)
    var file = await downloadAdjustListFile(fileObj.projectCode, fileObj.documentNumber, fileObj.id)
    // var file = await downloadInstallmentIncomeDetail(fileObj.pathFile)

    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()

    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={<AccountingPeriodWidget periodInfo={periodInfo} />}
      >
        {formSchema?.projectInfo && (
          <>
            <MiniProjectInfo schema={formSchema.projectInfo} />
            <br />
          </>
        )}

        <UpdateListVoucherListTable
          schema={formSchema}
          loading={isLoading}
          onSelect={handleSelect}
          onSearch={handleSearch}
          onDelete={(data) => {
            setDeleteAdjustId(data.id)
            setIsShowConfirmDelete(true)
          }}
          onPreview={handlePreviewVoucher}
        />
      </Panel>

      <ConfirmWidget
        title={`ยืนยัน`}
        show={isShowConfirmDelete}
        detail={`ยืนยันการลบรายการปรับปรุง`}
        onCancle={() => {
          setIsShowConfirmDelete(false)
          setDeleteAdjustId('')
        }}
        onConfirm={() => {
          setIsShowConfirmDelete(false)
          handleDelete(deleteAdjustId)
        }}
      />
    </>
  )
}
